/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from '@mui/material/Card'

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox'

// Material Dashboard 2 PRO React examples
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Footer from 'examples/Footer'
import DataTable from 'examples/Tables/DataTable'

import CrudService from 'services/cruds-service'
import { useState, useEffect } from 'react'
import moment from 'moment'
import { DataGrid } from '@mui/x-data-grid'
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput'
import { toast } from 'react-toastify'

function CronLog() {

  const [data, setData] = useState([])
  const [tableData, setTableData] = useState([])
  const [loader, setLoader] = useState(false)
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 100,
  });
  const [sortModel, setSortModel] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [rowCount, setRowCount] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);

  const callApi = async () => {
    setLoader(true)
    const sortField = sortModel[0]?.field || "id";
    const sortOrder = sortModel[0]?.sort || "DESC";
    const response = await CrudService.getCronLogs({
      page: paginationModel.page + 1,
      pageSize: paginationModel.pageSize,
      sortField,
      sortOrder,
      search: searchQuery
    })
    if (response.success) {
      setRowCount(response.count);
      setTableData(getRows(response.data));
    }
    setLoader(false)
  }

  const getRows = (info) => {
    let updatedInfo = info.map((row) => {
      return {
        id: row.id,
        device_id: row.device_id,
        error: row.error,
        created_at: row.created_at,
        'Device.ExternalDeviceMapping.external_device_id': row.Device?.ExternalDeviceMapping?.external_device_id ?? '-'
      }
    })
    return updatedInfo
  }

  const removeEvents = async (e) => {
    try {
      if (!confirm("Are you sure you want to delete this logs?")) {
        e.nativeEvent.stopImmediatePropagation();
      } else {
        await CrudService.delCronLogs(selectedRows);
        // for (const ids of selectedRows) {
        // }
        callApi();
        toast.success("The Logs successfully removed");
        setSelectedRows([]);
      }
    } catch (error) {
      console.error(error);
      if (error.hasOwnProperty("errors")) {
        // setNotification({
        //   value: true,
        //   text: error,
        // })
        toast.error("error");
      }
      return null;
    }
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      callApi();
    }, 500); // 500ms debounce

    return () => clearTimeout(debounceTimer);
  }, [paginationModel, sortModel, searchQuery])

  const columns = [
    { headerName: 'ID', field: 'id', width: 70 },
    { headerName: 'Device ID', field: 'device_id', width: 200 },
    { headerName: 'External Device ID', field: 'Device.ExternalDeviceMapping.external_device_id', width: 200 },
    { headerName: 'Logs', field: 'error', width: 400 },
    {
      headerName: 'Created Date',
      field: 'created_at',
      width: 300,
      isSortedDesc: true,
      isSorted: true,
      renderCell: (info) => {
        return (
          <div
            style={{
              whiteSpace: 'normal',
              maxWidth: '300px',
              wordWrap: 'break-word',
              wordBreak: 'break-word',
            }}
          >
            {moment(info.value).format(
              'MMMM DD, YYYY h:mm:ss A',
            )}
          </div>
        )
      },
    },
  ]

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={1} >
        <MDBox>
          <Card sx={{ height: 'calc(100vh - 140px)', color: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', margin: '10px' }}>
              <div>Cron Log</div>
              <div style={{ display: 'flex', gap: '10px' }} >
                {
                  selectedRows.length ?
                    <MDBox width="5rem" ml="auto">
                      <MDButton
                        size="small"
                        variant="gradient"
                        color="error"
                        fullWidth
                        onClick={() => (!loader ? removeEvents() : {})}
                        style={{ backgroundColor: "darkred" }}
                      >
                        Delete
                      </MDButton>
                    </MDBox> : <></>
                }
                <MDBox width="12rem" ml="auto">
                  <MDInput
                    placeholder="Search..."
                    value={searchQuery}
                    size="small"
                    fullWidth
                    onChange={({ currentTarget }) => {
                      // setPaginationModel({ ...paginationModel, page: 0 }); // Reset to first page on search
                      setSearchQuery(currentTarget.value);
                    }}
                  />
                </MDBox>
              </div>
            </div>
            <DataGrid
              rows={tableData}
              columns={columns}
              disableColumnFilter
              pagination
              paginationMode="server"
              sortingMode="server"
              rowCount={rowCount}
              paginationModel={paginationModel}
              pageSizeOptions={[25, 50, 100]} // ✅ Add this
              onSortModelChange={(model) => setSortModel(model)}
              onRowSelectionModelChange={(e) => setSelectedRows(e)}
              onPaginationModelChange={(newPage) => setPaginationModel(newPage)}
              // loading={loading}
              checkboxSelection
              disableSelectionOnClick
              sx={{ color: '#fff' }}
            />
          </Card>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default CronLog
